import React from "react"
import moment from 'moment'
import Text from "../Text"
import "./styles.scss"

const DateDisplay = ({ dateStr, className }) => {
  const date = moment(dateStr, 'YYYY-MM-DD').format('MMMM D, YYYY')
  return (
    <Text.Normal weight="lighter" className={`${className}`}>
      Posted on {date}
    </Text.Normal>
  )
}

export default DateDisplay
